import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios'

import { NETWORK_API_URL } from '../consts'
import { makeNetworkAiHeaders } from './headers'

export interface NetworkAiAuthorizeParams {
  onUnauthorized: () => void
}

export let authorizedNetworkAiFetch: AxiosInstance = axios.create({
  baseURL: NETWORK_API_URL,
  headers: makeNetworkAiHeaders(),
})

export const authorizeNetworkAiAxios = ({
  onUnauthorized,
}: NetworkAiAuthorizeParams): AxiosInstance => {
  authorizedNetworkAiFetch = axios.create({
    baseURL: NETWORK_API_URL,
    headers: makeNetworkAiHeaders(),
  })

  authorizedNetworkAiFetch.interceptors.response.use(
    (response: AxiosResponse) => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response
    },
    (error: AxiosError) => {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      if (error.response?.status === 401) {
        onUnauthorized()
      }

      return Promise.reject(error)
    }
  )

  return authorizedNetworkAiFetch
}
